// src/pages/AdminPanel.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AdminPanel.css";
import LogoutButton from "../components/LogoutButton";

const API_BASE =
  window.location.hostname === "localhost"
    ? "http://localhost/restaurant_api"
    : "https://menu-rtl.ir/restaurant_api";

export default function AdminPanel() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const fetchOrders = async () => {
    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${API_BASE}/view_orders.php`);
      const text = await res.text();

      try {
        const data = JSON.parse(text);
        if (Array.isArray(data)) setOrders(data);
        else setOrders([]);
      } catch (e) {
        setError("پاسخ نامعتبر از سرور");
      }
    } catch (e) {
      setError("ارتباط با سرور برقرار نشد");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
    const timer = setInterval(fetchOrders, 5000);
    return () => clearInterval(timer);
  }, []);

  const handlePrint = (filename) => {
    window.open(`${API_BASE}/print_order.php?file=${filename}`, "_blank");
    setTimeout(fetchOrders, 2000);
  };

  const handleDelete = async (filename) => {
    try {
      const res = await fetch(`${API_BASE}/delete_order.php?file=${filename}`);
      const json = await res.json();
      if (json.success) fetchOrders();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="admin-container container py-4">
      <div className="admin-header">
        <h1>سفارش‌ها</h1>

        <div className="admin-actions">
          <button className="btn-glass" onClick={() => navigate(`/settings`)}>
            تنظیمات
          </button>

          <button className="btn-glass" onClick={() => navigate(`/accounting`)}>
            حسابداری
          </button>

          <button className="btn-glass" onClick={fetchOrders}>
            بروزرسانی
          </button>

          <LogoutButton />
        </div>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {loading ? (
        <div className="text-center">در حال بارگذاری...</div>
      ) : orders.length === 0 ? (
        <p className="text-center">سفارش فعالی وجود ندارد.</p>
      ) : (
        <div className="row">
          {orders.map((order) => {
            const filename = order.filename;

            return (
              <div key={filename} className="col-md-6 col-lg-4 mb-3">
                <div className="order-card">
                  <div className="order-header">
                    <div className="order-table">میز {order.table}</div>
                    <div className="order-time">{order.time || "—"}</div>
                  </div>

                  <div className="order-items">
                    {order.items?.map((item, idx) => {
                      const itemTotal =
                        (item.price || 0) * (item.quantity || 1);

                      return (
                        <div key={idx} className="order-item">
                          {/* ⭐ نام فارسی */}
                          <div className="item-name">
                            {item.name_fa || item.name}
                          </div>

                          <div className="item-details">
                            تعداد: {item.quantity || 1}
                          </div>

                          <div className="item-price">
                            {itemTotal.toLocaleString()} تومان
                          </div>
                        </div>
                      );
                    })}
                  </div>

                  <div className="order-actions">
                    <button
                      className="btn-glass btn-glass-success"
                      onClick={() => handlePrint(filename)}
                    >
                      🖨️ چاپ
                    </button>

                    <button
                      className="btn-glass btn-glass-danger"
                      onClick={() => handleDelete(filename)}
                    >
                      🗑️ حذف
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
